import { ThreadErrorIcon } from "../../../icons";

export const Error = () => {
  return (
    <div className="tw-relative tw-flex tw-min-h-24 tw-w-[400px] tw-flex-col tw-items-center tw-overflow-hidden tw-rounded-lg tw-border tw-border-solid tw-border-blue-100 tw-bg-white tw-p-7 tw-shadow-comment-popover">
      <div className="tw-flex tw-w-[88px] tw-items-center tw-justify-center [&_svg]:tw-h-auto [&_svg]:tw-w-full">
        <ThreadErrorIcon />
      </div>
      <h2 className="tw-mb-1 tw-mt-4 tw-font-sans tw-text-lg tw-font-bold">
        Oops, something went wrong
      </h2>
      <p className="tw-m-0 tw-font-sans tw-text-[13px] tw-font-normal">
        Please{" "}
        <span
          className="tw-cursor-pointer tw-text-primary-base tw-transition-colors tw-duration-150 hover:tw-text-primary-500"
          onClick={() => window.location.reload()}
        >
          refresh the page
        </span>{" "}
        to try again.
      </p>
    </div>
  );
};
